export default "__VITE_ASSET__CCfF4xC4__"